// extracted by mini-css-extract-plugin
export default {"returns":"returns_returns__QN2H3","btns":"returns_btns__dY-zi","del":"returns_del__+N5a6","tab-btn":"returns_tab-btn__3uo8h","gray":"returns_gray__BI1Lq"};